import { Box, Button, Container, Fade, Paper, Typography } from "@mui/material";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import React, { useEffect, useState } from "react";
import cookies from "js-cookie";
import { BiCookie } from "react-icons/bi";

interface IProps {
  onClickEdit: () => void;
}

const Cookies: React.FC<IProps> = ({ onClickEdit }) => {
  const [display, setDisplay] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const { acceptAllCookies } = useCookieConsentContext();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const cookie = cookies.get("cookie-consent");
      if (cookie) {
        setAccepted(true);
        return;
      }
      setDisplay(true);
    }
  }, []);

  const dismiss = () => {
    if (typeof window !== "undefined") {
      try {
        cookies.set("cookie-consent", "accepted", {
          path: "/",
          // in a year
          expires: new Date(Date.now() + 31536000000),
        });
      } catch (e) {
        console.error(e);
      }
    }
    setAccepted(true);
    setTimeout(() => {
      setDisplay(false);
    }, 2500);
  };

  const acceptAll = () => {
    acceptAllCookies();
    dismiss();
  };

  if (!display) return null;

  return (
    <Box
      sx={(theme) => ({
        position: "fixed",
        bottom: 20,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.drawer + 1,
      })}
    >
      <Container maxWidth="md">
        <Fade in={!accepted}>
          <Paper
            sx={(theme) => ({
              padding: theme.spacing(4),
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: theme.spacing(2),
            })}
          >
            <Typography
              variant="h4"
              color="primary"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <BiCookie /> <span style={{ marginLeft: "8px" }}>Cookies</span>
            </Typography>
            <Typography>
              Pomocí cookies vylepšujeme příjemnost prohlížení a analyzujeme
              návštěvnost stránky. Kliknutím na „Přijmout vše“ vyjadřujete
              souhlas s tím, jak cookies používáme.
            </Typography>
            <Box
              sx={(theme) => ({
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
                width: "100%",
                marginTop: 2,
                [theme.breakpoints.down("md")]: {
                  flexDirection: "column",
                },
              })}
              color="primary"
            >
              <Button
                onClick={() => {
                  setDisplay(false);
                  onClickEdit();
                }}
                color="primary"
              >
                Upravit preference
              </Button>
              <Button onClick={acceptAll} variant="contained" color="primary">
                Přijmout vše
              </Button>
            </Box>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default Cookies;
